import { useNavigation } from "@react-navigation/native";
import { Button, Stack, View } from "@towersystems/roam-common-native";
import { Spacings } from "react-native-ui-lib";
import { FOOTER_BUTTON_WIDTH } from "../../../../constants";

type ScanNextContentProps = {
  stockCountId: string;
  onDismiss: () => void;
};

export function ScanNextContent({
  stockCountId,
  onDismiss,
}: ScanNextContentProps) {
  const { navigate } = useNavigation<any>();

  function handleOpenBarcodeScanner() {
    navigate("StockCountScannerScreen", {
      stockCountId: stockCountId,
    });
  }

  return (
    <Stack spacing={Spacings.s4}>
      <Button
        {...{
          fullWidth: true,
          label: "Scan Next",
          onPress: handleOpenBarcodeScanner,
          isAction: true,
        }}
        style={{
          flex: 1,
        }}
      />
      <View style={{ minWidth: FOOTER_BUTTON_WIDTH }}>
        <Button
          {...{
            fullWidth: true,
            label: "Dismiss",
            isDestructive: true,
            onPress: onDismiss,
            isAction: true,
          }}
        />
      </View>
    </Stack>
  );
}
